(function () {
    'use strict';

    a3_cabin_reports.directive('sectorHistory', sectorHistory);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name sectorHistory
    * @restrict E
    * @description
    *    Implementation of sector history
    * @example
    *   Usage:
    *   <sector-history></sector-history>
    * @ngInject
    */
    function sectorHistory() {
        function link(scope, element, attrs) {
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/TrainingReadOnly/sector-history.tpl.html',
            scope: {history : "="},
            link: link
        }
    }

})();
